import { HttpTokens, RemoveIncidentFile, QueryRemoveIncidentImage } from '@/src/types';
import { paramsQueryString } from '@/src/utils';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description delete image by id
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const IncidentFileRemove = (
  prefix: string = 'incidents/cache/file/remove',
  id: string,
  params: QueryRemoveIncidentImage,
  tokens: HttpTokens,
  hardRejection = true
): Promise<RemoveIncidentFile> => {
  /** provide higher timeout for upload */
  const instance = new AxiosService({ method: 'delete', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const queryUri = paramsQueryString(`${prefix}/${id}`, params);
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .delete(queryUri, config)
    .then((d: AxiosResponse<RemoveIncidentFile>) => {
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<RemoveIncidentFile>;
};
